// This page is Header for all pages
<template>
  <div class="max-h-screen bg-white">
    <nav class="bg-white border-b border-gray-200">
      <div class="max-w-10xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
             <img
                class="block lg:hidden h-8 sm:h-10 md:h-12 xl:h-14 w-auto"
                src="@/assets/Images/USL_bridge_stacked_positive.png"
                alt="U.S. Legal Services"
              />
              <img
                class="hidden lg:block h-8 sm:h-10 md:h-12 xl:h-14 w-auto"
                src="@/assets/Images/USL_bridge_stacked_positive.png"
                alt="U.S. Legal Services"
              />
            </div>
            <div class="hidden sm:-my-px sm:ml-6 sm:flex md:space-x-5 xl:space-x-8">
              <router-link
                to="/home"
                v-if="agent_user?.id"
                class="primary self-center border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Home </router-link>
              
              <router-link
              v-if="agent_user?.id && agent_user?.agent_access!=null && agent_user?.agent_access[0]==true" to="/commission_report" class="primary self-center border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium">
                    Commission Report
                  </router-link>
               
                  <router-link v-if="agent_user?.id && agent_user?.agent_access!=null && agent_user?.agent_access[1]==true"
          to="/membership_report" class="primary self-center border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium">
                    Membership Report
                  </router-link>
               
                  <router-link v-if="agent_user?.id && agent_user?.agent_access!=null && agent_user?.agent_access[2]==true"
          to="/company_statistics_report" class="primary self-center border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium">
                    Company Statistics Report
                  </router-link>
                  <div
                    v-if="agent_user?.id"
                    ref="quickLinksWrap"
                    class="primary relative border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
                    @mouseover="showDropdown = true"
                    @mouseleave="hideDropdown"
                    @click.stop
                  >
                <button
                  type="button"
                  class="text-[#ba4224] hover:text-[#ba4224] px-3 py-2 cursor-pointer focus:outline-none focus:underline border-0 bg-transparent font-inherit text-inherit"
                  aria-haspopup="true"
                  :aria-expanded="showDropdown ? 'true' : 'false'"
                  aria-controls="quick_link"
                  aria-label="Quick Links"
                  title="Quick Links"
                  @mouseover="showDropdown = true"
                  @focus="showDropdown = true"
                  @keydown="onQuickLinksKeydown"
                  ref="dropdown"
                  v-if="agent_user?.is_agent=='Yes' && agent_user?.agent_access!=null && (agent_user?.agent_access[3]==true || agent_user?.agent_access[4]==true || agent_user?.agent_access[5]==true || agent_user?.agent_access[6]==true)"
                >
                  Quick Links
                </button>
                <ul
                  v-if="showDropdown"
                  class="absolute top-3/4 left-0 w-48 bg-white rounded-lg shadow-md z-10 list-none m-0 p-0"
                  id="quick_link"
                  aria-label="Quick Links"
                  @mouseenter="mouseInDropdown = true"
                  @mouseleave="mouseInDropdown = false"
                  @click.stop
                >
                <li v-if="agent_user?.agent_access!=null && agent_user?.agent_access[3]==true">
                <router-link @mouseenter="focusMenuItem" @mouseleave="showDropdown = false" @click="RedirectTopage('','https://apps.uslegalservices.net/asso/Agent_Event.asp')" to="#" class="primary self-center block px-4 py-2 text-gray-800 hover:bg-gray-100 border-b-0">
          Supply Order Form
                  </router-link>
                </li>
                <li v-if="agent_user?.agent_access!=null && agent_user?.agent_access[4]==true">
                  <router-link @mouseenter="focusMenuItem" @mouseleave="showDropdown = false" @click="RedirectTopage('','https://apps.uslegalservices.net/CEF/')" to="#" class="self-center block px-4 py-2 text-gray-800 hover:bg-gray-100 border-b-0">
          Company Enrollment Form
                  </router-link>
                </li>
                <li v-if="agent_user?.agent_access!=null && agent_user?.agent_access[5]==true && agent_user?.associateNumber=='NAZ603'">
                  <router-link @mouseenter="focusMenuItem" @mouseleave="showDropdown = false"  @click="RedirectTopage('','https://enroll.uslegalservices.net/enroll?opt=CMP504')" to="#" class="self-center block px-4 py-2 text-gray-800 hover:bg-gray-100 border-b-0">
          Application Entry
                  </router-link>
                </li>
                <li v-if="agent_user?.agent_access!=null && agent_user?.agent_access[5]==true && agent_user?.associateNumber!='NAZ603'">
                  <router-link @mouseenter="focusMenuItem" @mouseleave="showDropdown = false"  @click="RedirectTopage('','https://apps.uslegalservices.net/services/App_test2/agent_2024.asp?A='+agent_user?.associateNumber)" to="#" class="self-center block px-4 py-2 text-gray-800 hover:bg-gray-100 border-b-0">
          Application Entry
                  </router-link>
                </li>
                <li v-if="agent_user?.agent_access!=null && agent_user?.agent_access[6]==true">
                  <router-link @mouseenter="focusMenuItem" @mouseleave="showDropdown = false"  @click="generateQTURL()" to="#" class="self-center block px-4 py-2 text-gray-800 hover:bg-gray-100 border-b-0">
          Quoting Tool
                  </router-link>
                </li>
                </ul>
              </div>  
              <router-link
              v-if="token==''"
                to="/login"
                class="primary self-center border-transparent inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Log In</router-link>
            </div>
          </div>
          <div
            class="hidden sm:ml-6 sm:flex sm:items-center"
            v-if="agent_user?.id"
          >
            <div class="ml-3 relative">
              <div>
                <button
                  class="max-w-xs bg-white flex items-center md:text-xs xl:text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  id="user-menu"
                  type="button"
                  aria-controls="user-menu-item"
                  aria-haspopup="true"
                  :aria-label="`User menu, ${agent_user?.email || agent_user?.AgentName || 'current user'}`"
                  :title="agent_user?.email || agent_user?.AgentName || 'User menu'"
                  @click="openPopup"
                  @keydown.enter.prevent="openPopup"
                  @keydown.space.prevent="openPopup"
                  @mouseenter="focusMenuItem"
                >
                  <span class="sr-only">Open user menu</span>
                  <div class="ml-3">
                    <div
                      class="primary md:text-xs xl:text-sm font-medium"
                      v-if="agent_user?.id"
                    >
                      <span
                        id="user-email"
                        class="w-full"
                        v-if="
                          agent_user?.email != '' &&
                            agent_user?.email != null
                        "
                      >
                        <i class="fa fa-user mr-1"></i>
                        {{ agent_user?.email }}
                      </span>
                      <span
                        id="user-email"
                        class="w-full"
                        v-if="
                          agent_user?.email == '' ||
                            agent_user?.email == null
                        "
                      >
                        <i class="fa fa-user mr-1"></i>
                        {{ agent_user?.AgentName }}
                      </span>
                    </div>
                   
                  </div>
                </button>
                <div
                  class="active-header origin-top-right absolute mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5"
                  role="menu"
                  id="user-menu-item"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  <a
                  v-if="agent_user?.id"
                    href="#"
                    class="primary block px-4 py-2 md:text-xs xl:text-sm hover:bg-gray-100"
                    role="menuitem"
                    @click="signOut"
                  >Sign out</a>
                </div>
              </div>
            </div>
          </div>
          <div class="-mr-2 flex items-center sm:hidden">
            <button
              @click="openSubMenu"
              class="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Open main menu</span>
              <svg
                class="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                class="hidden h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="hidden sm:hidden" id="mobile-view-menu">
        <div class="pt-2 pb-3 space-y-1">
          <router-link
            to="/home"
            v-if="agent_user?.id"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Home</router-link>
         
          <router-link
          v-if="agent_user?.id"
            to="/login"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Log In</router-link>
        </div>
        <div class="pt-4 pb-3 border-t border-gray-200">
          <div class="flex items-center">
            <div
              class="ml-3"
              v-if="agent_user?.id">
              <div
                class="md:text-xs xl:text-sm font-medium text-gray-500"
                >
                <span
                  id="user-email"
                  class="w-full"
                  v-if="
                    agent_user?.email != '' && agent_user?.email != null
                  "
                >
                  <i class="fa fa-user mr-1"></i>
                  {{ agent_user?.email }}
                </span>
                <span
                  id="user-email"
                  class="w-full"
                  v-if="
                    agent_user?.email == '' || agent_user?.email == null
                  "
                >
                  <i class="fa fa-user mr-1"></i>
                  {{ agent_user?.AgentName }}
                </span>
              </div>
            </div>
          </div>
          <div class="mt-3 space-y-1">
            <a
              v-if="agent_user?.id"
              href="#"
              @click="signOut"
              class="primary block px-4 py-2 text-base font-medium hover:bg-gray-100"
            >Sign out</a>
          </div>
        </div>
      </div>
      <h2 class="text-md leading-6 font-medium cobalt-text-color px-8"  v-if="agent_user?.id">
          <p class="text-black py-2">Data for Agent: {{agent_user?.AgentName}} 
            <button class="text-sm Pmt-2 cobalt-text-color inline-flex border-b-2 border-current cursor-pointer focus:outline-none focus:underline" @click="$router.push('/select-agent')" v-if="agent_list.length>1">click to change agent</button></p>
        </h2>
    </nav>
  </div>
</template>
<script>
import $ from "jquery";
import { mapState } from "vuex";
import Constants from "../../constants.ts";

export default {
  data() {
    return {
      showDropdown: false,
      mouseInDropdown: false,
      query_string:'',
      BASE_EXT: Constants.BASE_EXT
    }
  },
  name: "Header",
  computed: mapState(["agent_user","token","agent_list"]),
  mounted: function() {
    var isMenuOpen = false;
    $("#nav-toggle").click(function() {
      isMenuOpen = !isMenuOpen;
      $(this).attr("aria-expanded", isMenuOpen);
      $("#nav-content").attr("aria-expanded", isMenuOpen);
    });
    $("body").click(function(event) {
      if (event.target.id != "user-email") {
        $("#user-menu-item").addClass("active-header");
      }
    });

    this._onBodyClick = (event) => {
      const wrap = this.$refs.quickLinksWrap;
      if (wrap && event?.target && wrap.contains(event.target)) return;
      this.showDropdown = false;
    };
    document.body.addEventListener("click", this._onBodyClick);
  },
  beforeUnmount() {
    if (this._onBodyClick) {
      document.body.removeEventListener("click", this._onBodyClick);
    }
  },
  methods: {
    focusMenuItem(e) {
      // Move focus with mouse hover so screen readers announce items.
      e?.currentTarget?.focus?.();
    },
    onQuickLinksKeydown(e) {
      if (!e) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.showDropdown = !this.showDropdown;
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.showDropdown = true;
        this.$nextTick(() => {
          const menu = document.getElementById("quick_link");
          const first = menu?.querySelector?.("a");
          first?.focus?.();
        });
      } else if (e.key === "Escape") {
        e.preventDefault();
        this.showDropdown = false;
        this.$nextTick(() => {
          this.$refs?.dropdown?.focus?.();
        });
      }
    },
    dynamicQueryString() {
    let query = JSON.parse(localStorage.getItem('query'));
    return `opt=${query.opt}&u=${query.u}&c=${query.c}&AGENTID=${query.AGENTID}&AUTH=${query.AUTH}`;
  },
  generateQTURL() {
      let url;
    if(this.agent_user?.agent_access[7]==true){
      url=this.BASE_EXT+"usl-customer-portal/quote_tool/#!/dashboard?u="+this.agent_user.associateNumber+"&ac=ac&c=A&AGENTID="+this.agent_user.id
          window.open(url, '_blank');
    }else if(this.agent_user?.agent_access[8]==true){
      url=this.BASE_EXT+"usl-customer-portal/quote_tool/#!/dashboard?u="+this.agent_user.associateNumber+"&ac=ex&c=A&AGENTID="+this.agent_user.id    
    }else{
      url=this.BASE_EXT+"usl-customer-portal/quote_tool_usl/#!/dashboard?u="+this.agent_user.associateNumber+"&c=A&AGENTID="+this.agent_user.id
    }
    window.open(url, '_blank');
    },
    hideDropdown() {
      setTimeout(() => {
        const dropdown = this.$refs.dropdown;
        if (!this.mouseInDropdown && !dropdown?.querySelector?.(':hover')) {
          this.showDropdown = false;
        }
      }, 200);
    },
    openSubMenu: function() {
      $("#mobile-view-menu").toggleClass("hidden");
    },
    openPopup: function() {
      $("#user-menu-item").toggleClass("active-header");
    },
    RedirectTopage(page='',path=''){
      if(path!=''){
        window.open(path,'_blank');
      }else{
        this.$router.push(page);
      }
    },
    signOut: function() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
#quick_link .router-link-active{
  border-bottom:0;
}
</style>